import {
  ControllerGlobals,
  IS_READ_ONLY_USER,
  isMobile,
  toastInfo
} from "src/components/Planner/controller";
import $ from "jquery";
import * as d3 from "d3";
import {
  UDevGlobals,
  getDeviceById,
  getGroupsOfDevice,
  getSerialCenter,
  getSerialCenter2d,
  getSerialOfDeviceId,
  isDeviceMergedById,
  uDev
} from "src/components/Planner/planner/uDev";
import { getProductOfDevice } from "src/components/Planner/planner/uDev-dom";
import { isSerialConnectedWithOther } from "src/components/Planner/planner/serialConnections";
import { addNewDesignIdToDefaultSerial, detachFromSerial } from "src/components/Planner/planner/serialConnections-dom";
import {
  maxCircuitsForSwitch,
  recalcSwitchInProgress
} from "src/components/Planner/planner/grouping";
import {
  P_numtoxy,
  P_xytonum,
  uMath
} from "src/components/Planner/planner/uMath";
import {ts} from "src/utils/translate";
import {
  UnGroupDeviceAction
} from "src/components/Planner/planner/history/group-actions";
import {
  DeleteSingleDeviceAction,
  PopOutFromSerialAction
} from "src/components/Planner/planner/history/device-actions";
import {
  currCenterPoint,
  draw_groupMeMove,
  getClientPlannerScaleRatio,
  handleLongPress,
  hideTools,
  highlightPoint,
  isPlannerBusy,
  removeDeviceFromGroup,
  setMode
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import {removeDevice} from "src/components/Planner/planner/deviceDrawing";
import {
  isCategoryLocked
} from "src/components/Planner/planner/categoryDisplayHandler";
import {getFrontendURL} from "src/utils/url";

let _callbacks = { onReplaceDevice: null, onEditFrame: null, onChangeDesign: null };

export function setDeviceToolsCallbacks({ onReplaceDevice, onEditFrame, onChangeDesign }) {
    _callbacks.onReplaceDevice = onReplaceDevice;
    _callbacks.onEditFrame = onEditFrame;
    _callbacks.onChangeDesign = onChangeDesign;
}

export function createToolTooltip(selector) {
  $(selector).tooltip({
    'container': 'body',
    'placement': 'top',
    'trigger': 'hover',
    'template': '<div class="tooltip device-tool-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
  });
}

/**
 *
 * @param {d3.Selection<any>} targetContainer
 * @param {{x: number, y: number, width: number, height: number, transform: string?}} rectBox
 * @param {object} extraAttrs
 * @param {"top"| "bottom"} triangleAlignment
 */
export function drawToolBackground(targetContainer, rectBox, extraAttrs = {},
    triangleAlignment = "bottom") {
  let trianglePts = [];

  if (triangleAlignment == "bottom") {
    trianglePts = [
      {x: rectBox.x + rectBox.width / 2 - 2, y: rectBox.y + rectBox.height - 1},
      {x: rectBox.x + rectBox.width / 2 + 2, y: rectBox.y + rectBox.height - 1},
      {x: rectBox.x + rectBox.width / 2, y: rectBox.y + rectBox.height + 1},
    ];
  } else if (triangleAlignment == "top") {
    trianglePts = [
      {x: rectBox.x + rectBox.width / 2 - 2, y: rectBox.y + 1},
      {x: rectBox.x + rectBox.width / 2 + 2, y: rectBox.y + 1},
      {x: rectBox.x + rectBox.width / 2, y: rectBox.y - 1},
    ];
  }

  const mainRect = targetContainer.append("rect")
    .attr('width', rectBox.width)
    .attr('height', rectBox.height)
    .attr('x', rectBox.x)
    .attr('y', rectBox.y)
    .attr('rx', rectBox.height / 6)
    .attr('fill', 'white')
    .attr('stroke', 'gray')
    .attr('stroke-width', 0)
    .style('filter', 'drop-shadow(0px 0px 2px rgba(0, 0, 0, .40))');

  const overPoly = targetContainer.append('polygon')
    .attr('points', trianglePts.map(pt => pt.x + "," + pt.y).join(' '))
    .attr('fill', 'white')
    .attr('stroke', 'white')
    .attr('stroke-width', 0);

  if (typeof extraAttrs === "object" && extraAttrs) {
    [/* underPoly, */ mainRect, overPoly].forEach(elem => {
      for (let i in extraAttrs) {
        elem.attr(i, extraAttrs[i]);
      }
    });
  }
  return mainRect;
}

export function getToolSize() {
  let size = PlannerGlobals.DEVICE_SIZE / 1.6;
  size = Math.max(4, size);

  let padding = size / 2.75;
  let spacing = padding / 1.1;

  size = Math.round(size * 100) / 100;
  padding = Math.round(padding * 100) / 100;
  spacing = Math.round(spacing * 100) / 100;

  return {size, padding, spacing};
}

/**
 * Showing the hotkeys around a device
 *
 * @param {any} elem The sender element
 */
export function showTools(elem) {

  if (IS_READ_ONLY_USER) {
    return;
  }

  let showToolsDesignWindow = localStorage.getItem('showToolsDesignWindow');
  if (showToolsDesignWindow == null) {
    showToolsDesignWindow = 'true';
  }

  if ($(elem).hasClass('dev-ghost')
      || ControllerGlobals.currentlyDraggedDevice) {
    return;
  }
  if (PlannerGlobals.hideRedXTimeout) {
    clearTimeout(PlannerGlobals.hideRedXTimeout);
  }

  var d3Data = d3.select(elem.parentNode).datum();
  var deviceId = d3.select(elem).attr("data-deviceId");
  var dev = getDeviceById(deviceId);
  var serial = getSerialOfDeviceId(deviceId);
  var serConn = serial && isSerialConnectedWithOther(serial.id);

  if (!dev || dev.groupingProgress || dev.ghost || dev.nopermission ||
      isCategoryLocked(dev.category_id)
      || UDevGlobals.devIsChangingTo[dev.deviceId]) {
    return;
  }

  if (recalcSwitchInProgress) {
    return;
  }
  hideTools();

  var groupsOfDev = getGroupsOfDevice(deviceId).length;
  var maxGroupsOfDev = dev.input ? maxCircuitsForSwitch(dev) : 1;

  var devCenterPos = P_xytonum(uDev.getCenterOfDevice_NoDOM(deviceId));

  let numDevTools = 2; // rotate, delete/ungroup, modify by default
  if (dev.groupable && groupsOfDev < maxGroupsOfDev
      && !PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
    numDevTools++;
  }
  if (deviceId.indexOf('S_') === -1) {
    numDevTools++;
  }
  if (serial && serial.deviceIds.length > 1) {
    numDevTools++;
  }
  if (serial) {
    numDevTools++;
  }

  if (dev.has_design) {
    numDevTools++;
  }

  const sizes = getToolSize();
  const toolSize = sizes.size;
  const toolPadding = sizes.padding;
  const toolSpacing = sizes.spacing;
  var fullRectWidth = numDevTools * toolSize + (numDevTools - 1) * toolSpacing
      + toolPadding * 2;
  var fullRectHeight = toolSize + toolPadding * 2;
  var yPos = -toolSize - PlannerGlobals.DEVICE_SIZE / 2 - toolPadding * 1.5 - 2;
  var xPos = -fullRectWidth / 2;
  var maxHeight = 40;
  var adjustedHeight = Math.min(fullRectWidth / 1.2, maxHeight);

  const rectBox = {
    width: fullRectWidth,
    height: fullRectHeight,
    x: xPos,
    y: yPos,
  };

  let rectBox2WidthPlus = 0;
  if (PlannerGlobals.DEVICE_SIZE == 16) {
    rectBox2WidthPlus = 35;
  } else if (PlannerGlobals.DEVICE_SIZE == 12) {
    rectBox2WidthPlus = 20;
  } else if (PlannerGlobals.DEVICE_SIZE == 4) {
    rectBox2WidthPlus = -10;
  }

  const extraAttrs = {
    transform: "translate(" + devCenterPos + ")",
    class: 'device-tool',
    'data-deviceToolId': d3Data.devices[0].deviceId,
  };

  if (!dev.image_url) {
    drawToolBackground(PlannerGlobals.container, rectBox, extraAttrs);
  } else if (dev.image_url && showToolsDesignWindow == 'true') {
    const rectBox2 = {
      width: fullRectWidth + 10,
      height: fullRectHeight + 55 + rectBox2WidthPlus,
      x: xPos - 5,
      y: yPos - 55 - rectBox2WidthPlus,
    };
    const extraAttrs2 = {
      transform: "translate(" + devCenterPos + ")",
      class: 'device-tool',
      position: 'fixed',
      'data-deviceToolId': d3Data.devices[0].deviceId,
      'rx': 5,
      'ry': 5
    };

    drawToolBackground(PlannerGlobals.container, rectBox2, extraAttrs2);

    PlannerGlobals.container.append("svg:image")
    .attr('x', xPos + (fullRectWidth / 2) - (adjustedHeight
        / 2))// konténer fele + a elem MAGASÁGA fel a kező kordináta
    .attr('y', yPos - 40 - rectBox2WidthPlus)
    //    .attr('width', fullRectWidth / 1.2)
    //    .attr('height', fullRectWidth / 1.2)
    .attr('width', adjustedHeight)
    .attr('height', adjustedHeight)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/' + dev.image_url)
    .attr('data-deviceToolId', dev.deviceId)
    .attr('preserveAspectRatio', 'none')
    .attr('text-anchor', 'middle')
    //.attr("class", dev.has_design ? 'device-tool device-image-url device-image-with-design disable-filter' : 'device-tool device-image-url disable-filter')
    .attr("class",
        dev.has_design ? 'device-tool device-image-url device-image-with-design'
            : 'device-tool device-image-url disable-filter')
    .attr('id', "dev_image_" + dev.deviceId);

    PlannerGlobals.container.append("svg:text")
    .attr('y', yPos - 47 - rectBox2WidthPlus)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr('width', fullRectWidth)
    .attr('height', 15)
    .attr("class", "device-tool")
    .attr('xmlns', 'http://www.w3.org/1999/xhtml')
    .attr("font-size", 3)
    .attr('text-anchor', 'middle')
    .attr('id', "device-text-manufacturer-" + dev.deviceId)
    .text(dev.device_manufacturer).style('text-align', 'center');

    PlannerGlobals.container.append("svg:text")
    .attr('y', yPos - 42 - rectBox2WidthPlus)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr('width', fullRectWidth)
    .attr('height', 15)
    .attr("class", "device-tool")
    .attr('xmlns', 'http://www.w3.org/1999/xhtml')
    .attr("font-size", 3)
    .attr('text-anchor', 'middle')
    .attr('id', "device-text-color-" + dev.deviceId)
    .text(dev.device_color).style('text-align', 'center')
    .each(function () {
      if (this.getComputedTextLength() <= fullRectWidth) { return; }
      const self = d3.select(this);
      const words = (dev.device_color || '').split(/\s+/);
      const startY = yPos - 42 - rectBox2WidthPlus;
      const lineHeight = 4;
      self.text(null);
      let line = [];
      let lineNum = 0;
      let tspan = self.append("tspan").attr("x", 0).attr("y", startY);
      words.forEach(function (word) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > fullRectWidth && line.length > 1) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          lineNum++;
          tspan = self.append("tspan").attr("x", 0).attr("y", startY + lineNum * lineHeight).text(word);
        }
      });
    });

    PlannerGlobals.container.append("svg:image")
    .attr('x', xPos + (fullRectWidth) - 3)
    .attr('y', yPos - 52 - rectBox2WidthPlus)
    .attr('width', 4)
    .attr('height', 4)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() +'/images/arrow_down.svg')
    .attr('data-deviceToolId', dev.deviceId)
    .attr('preserveAspectRatio', 'none')
    .attr("class", "device-tool device-image-url")
    .attr('id', "close-design-button");
  }

  if (dev.image_url && showToolsDesignWindow == 'false') {
    drawToolBackground(PlannerGlobals.container, rectBox, extraAttrs);
    const openingBoxPts = [
      {x: rectBox.x + rectBox.width / 2 - 6, y: rectBox.y - 0},
      {x: rectBox.x + rectBox.width / 2 - 4, y: rectBox.y - 2.5},
      {x: rectBox.x + rectBox.width / 2 + 4, y: rectBox.y - 2.5},
      {x: rectBox.x + rectBox.width / 2 + 6, y: rectBox.y - 0},
    ];

    const trianglePts = [
      {x: rectBox.x + rectBox.width / 2 - 1, y: rectBox.y - 0.73},
      {x: rectBox.x + rectBox.width / 2, y: rectBox.y - 1.73},
    ];

    const trianglePts2 = [
      {x: rectBox.x + rectBox.width / 2 + 1, y: rectBox.y - 0.73},
      {x: rectBox.x + rectBox.width / 2, y: rectBox.y - 1.73},
    ];

    PlannerGlobals.container.append('polygon')
      .attr('points', openingBoxPts.map(pt => pt.x + "," + pt.y).join(' '))
      .attr('fill', 'white')
      .attr('stroke', 'white')
      .attr('stroke-width', 0)
      .attr('transform', "translate(" + devCenterPos + ")")
      .attr('class', 'device-tool')
      .attr('data-deviceToolId', d3Data.devices[0].deviceId)
      .attr('id', 'open-design-button')
      .style('filter', 'drop-shadow(0px 0px 2px rgba(0, 0, 0, .40))');

    PlannerGlobals.container.append('polygon')
      .attr('points', trianglePts.map(pt => pt.x + "," + pt.y).join(' '))
      .attr('fill', 'gray')
      .attr('stroke', 'gray')
      .attr('transform', "translate(" + devCenterPos + ")")
      .attr('class', 'device-tool')
      .attr('stroke-width', 0.1);

    PlannerGlobals.container.append('polygon')
      .attr('points', trianglePts2.map(pt => pt.x + "," + pt.y).join(' '))
      .attr('fill', 'gray')
      .attr('stroke', 'gray')
      .attr('transform', "translate(" + devCenterPos + ")")
      .attr('class', 'device-tool')
      .attr('stroke-width', 0.1);

    /*let rectBox2SvgElement = drawToolBackground(container, rectBox2, extraAttrs2);
        container.append("svg:image")
            .attr('width', '25px')
            .attr('height', '25px')
            .attr("x", '-12px')
            .attr("y", yPos - 40)
            .attr("transform", "translate(" + devCenterPos + ")")
            .attr("xlink:href", dev.image_url)
            .attr('data-deviceToolId', dev.deviceId)
            .attr('preserveAspectRatio', 'none')
            .attr("class", "device-tool device-image-url")
            .attr('id', "dev_image_" + dev.deviceId);*/
  }
  xPos += toolPadding;
  yPos += toolPadding;

  if (groupsOfDev > 0) {
    // unchain button
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/ungroup.svg')
    .attr("title", ts("p_tool_group_del", "Remove from group"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool uplan-touchable")
    .attr("id", "unchain-tool");

    $('#unchain-tool').off('mouseup');
    $('#unchain-tool').on('mouseup', function (e) {
      /*             e.preventDefault();
                        e.stopImmediatePropagation(); */
      if (!dev.ghost) {
        var grps = getGroupsOfDevice(deviceId);
        removeDeviceFromGroup(deviceId, function () {
          if ($('[data-deviceToolId="' + dev.deviceId + '"]').length) {
            showTools(elem);
          }
          var action = new UnGroupDeviceAction(deviceId, grps);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        });
      }
    });

    xPos += toolSize + toolSpacing;
  } else {
    // delete button
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/delete.svg')
    .attr("title", ts("p_tool_delete", "Delete"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool uplan-touchable")
    .attr("id", "redx");

    xPos += toolSize + toolSpacing;
  }

  // remove dev from frame btn
  if (serial && serial.deviceIds.length > 1) {
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/detach.svg')
    .attr("title", ts("frm_popout", "Remove from frame"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool uplan-touchable")
    .attr('id', 'frame-detach-btn');

    xPos += toolSize + toolSpacing;
  }

  // edit button
  if (deviceId.indexOf('S_') === -1) {

    const classString = isDeviceMergedById(deviceId) === false
        ? 'device-tool uplan-touchable' : 'device-tool disable';

    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/replace.svg')
    .attr("title", ts("p_tool_replace", "Replace"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", classString)
    .attr('id', 'dev-edit-btn');

    xPos += toolSize + toolSpacing;
  }
  if (dev.has_design) {
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/change_design_new.svg?v=1')
    .attr("title", ts("p_tool_design_replace", "Design Replace"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool uplan-touchable")
    .attr('id', 'dev-edit-design-btn');

    xPos += toolSize + toolSpacing;
  }

  // frame tool
  if (serial) {
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/adjust-frame.svg')
    .attr("title", ts("frm_adjust", "Adjust frame"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool uplan-touchable")
    .attr('id', 'frame-edit-btn');

    xPos += toolSize + toolSpacing;
  }

  // chain button
  if (dev.groupable && groupsOfDev < maxGroupsOfDev
      && !PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
    PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", xPos)
    .attr("y", yPos)
    .attr("transform", "translate(" + devCenterPos + ")")
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/group.svg')
    .attr("title", ts("p_tool_group_add", "Add to group"))
    .attr('data-deviceToolId', dev.deviceId)
    .attr("class", "device-tool")
    .attr("id", "chain-tool");

    $('#chain-tool').off('click');
    $('#chain-tool').on('click', function (e) {
      if (!dev.ghost) {
        hideTools();
        setMode.groupMe(deviceId);
        draw_groupMeMove();
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    xPos += toolSize + toolSpacing;
  }

  // rotate btn
  PlannerGlobals.container
  .append("svg:image")
  .attr('width', toolSize)
  .attr('height', toolSize)
  .attr("x", xPos)
  .attr("y", yPos)
  .attr("transform", "translate(" + devCenterPos + ")")
  .attr("xlink:href", getFrontendURL() + '/images/planner_tools/rotate.svg')
  .attr("title", ts("p_tool_rotate", "Rotate"))
  .attr('data-deviceToolId', d3Data.devices[0].deviceId)
  .attr("class", "device-tool")
  .attr("id", "rotate-tool");

  $('#rotate-tool').off('click');
  $("#rotate-tool").on('click', function (e) {
    hideTools();
    setMode.rotateMe(elem.parentNode);
    e.stopImmediatePropagation();
    e.preventDefault();
  });

  createToolTooltip(".device-tool");

  $('#chain-tool, #dev-edit-btn, #frame-edit-btn, #redx, #unchain-tool, #rotate-tool, #dev-edit-design-btn').on(
      'mousedown', function (e) {
        e.stopPropagation();
        e.preventDefault();
      })

  //if device is not yet grouped
  /**
   * groupable condition end
   */
  if (!isMobile) {
    if (PlannerGlobals.hideRedXTimeout) {
      clearTimeout(PlannerGlobals.hideRedXTimeout);
    }
    PlannerGlobals.hideRedXTimeout = setTimeout(function () {
      hideTools();
    }, 2500);

    $('.device-tool').on('mouseout', function () {
      if (PlannerGlobals.hideRedXTimeout) {
        clearTimeout(PlannerGlobals.hideRedXTimeout);
      }
      PlannerGlobals.hideRedXTimeout = setTimeout(function () {
        hideTools();
      }, 2500);
    });
  }

  $('.device-tool').on('mouseenter', function () {
    if (!isMobile && PlannerGlobals.hideRedXTimeout) {
      clearTimeout(PlannerGlobals.hideRedXTimeout);
    }
  });

  var longPressTimeout;
  var hasLongPressed;
  var isAbleToShortPress;

  $('#redx').on('mousedown', function (e) {
    if (e.which !== 1) {
      return;
    }
    if (PlannerGlobals.hideRedXTimeout) {
      clearTimeout(PlannerGlobals.hideRedXTimeout);
    }
    hasLongPressed = false;
    isAbleToShortPress = true;
    longPressTimeout = setTimeout(function () {
      hasLongPressed = true;
      handleLongPress(deviceId);
    }, 600);
    return false;
  });

  $('#redx').on('mouseup', function (e) {
    if (e.which !== 1) {
      return;
    }
    if (longPressTimeout) {
      clearTimeout(longPressTimeout);
    }
    if (!hasLongPressed && isAbleToShortPress) {
      var dev = getDeviceById(deviceId);
      if (dev && !UDevGlobals.devIsChangingTo[dev.deviceId]) {

        var busyReason = isPlannerBusy();
        if (busyReason) {
          toastInfo(busyReason);
          return;
        }

        removeDevice(this, deviceId)
        .done(function (params) {
          var action = new DeleteSingleDeviceAction(params);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        });
      }
    }
    return false;
  });

  $('#redx').on('mouseleave', function () {
    isAbleToShortPress = false;
    if (longPressTimeout) {
      clearTimeout(longPressTimeout);
    }
  });

  $('#dev-edit-btn').on('click', function () {
    _callbacks.onReplaceDevice?.(deviceId);
  });

  $('#dev-edit-design-btn').on('click', function () {
    _callbacks.onChangeDesign?.(deviceId);
  });

  $('.device-image-with-design').on('click', function () {
    _callbacks.onChangeDesign?.(deviceId);
  });

  $('#frame-detach-btn').on('click', function (e) {
    const dev = getDeviceById(deviceId);
    const oldProductId = dev.product_id;

    const prod = getProductOfDevice(dev);
    const ser = getSerialOfDeviceId(deviceId);

    detachFromSerial(deviceId).then((newDevId) => {
      const newSer = getSerialOfDeviceId(newDevId);
      if (newSer) {
        const action = new PopOutFromSerialAction(newDevId, serial.id,
            newSer.id);
        PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        addNewDesignIdToDefaultSerial(oldProductId, newDevId);
      }
    });
  });

  $('#open-design-button').on('click', function (e) {
    hideTools();
    localStorage.setItem('showToolsDesignWindow', true);
    showTools(elem);
  });

  $('#close-design-button').on('click', function (e) {
    hideTools();
    localStorage.setItem('showToolsDesignWindow', false);
    showTools(elem);
  });

  $('#frame-edit-btn').on('click', function (e) {
    const centerOffset = (d3Data.connId ? getSerialCenter2d(d3Data.allColsNum,
            d3Data.allRowsNum) :
        getSerialCenter(d3Data.devices.length)).split(" ").map(x => +x);

    const plannerPos = $('#plannerSVG').position();
    const scale = getClientPlannerScaleRatio(5);
    const highlightedPt = {
      x: d3Data.x + centerOffset[0],
      y: d3Data.y + centerOffset[1]
    }

    highlightedPt.x += (plannerPos.left - 20) / scale / 2;
    highlightedPt.y += (plannerPos.top - 20) / scale / 2;

    let timeout = 0;

    const currPt = P_numtoxy(currCenterPoint());

    if (uMath.pointDistance(highlightedPt, currPt) > 5 || Math.abs(
        PlannerGlobals.scalevar - 5) > 0.4) {
      highlightPoint(highlightedPt.x, highlightedPt.y, 5, 300);
      timeout = 350;
    }

    setTimeout(() => {
      if (d3Data.connId) {
        d3.select('[data-serConnId="' + d3Data.connId + '"]').style('opacity',
            0);
      } else if (d3Data.id) {
        d3.select('[data-serialId="' + d3Data.id + '"]').style('opacity', 0);
      }
      hideTools();
      if (serial) {
        _callbacks.onEditFrame?.(serial.id);
      }
    }, timeout);
  });

  /* $('#comment-tool').on('click', function () {
        showComments(elem);
    }); */

  $('#redx, #comment-tool').on('mouseenter', function () {
    if (!isMobile && PlannerGlobals.hideRedXTimeout) {
      clearTimeout(PlannerGlobals.hideRedXTimeout);
    }
  });
}

export function showRotateTool(elem) {
  return;
}